import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { SentryService } from '../services/sentry.service';
import { GlobalMessageService } from '../services/global-message.service';
import { AuthService } from '../services/auth.service';
import { DriftService } from '../services/drift.service';


import { FormValidators } from '../global/form-validators';
import { Animations } from '../global/animations';

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  animations: Animations.authForms
})
export class NewUserComponent implements OnInit {

  @ViewChild('invalidGoogleDialog') invalidGoogleDialog: TemplateRef<any>;

  invalidGoogleDialogRef: BsModalRef;

  passwordForm: FormGroup;
  visible: string = 'off';
  token: string = '';
  emailAddress: string = '';
  googleEmailAddress: string = '';
  validToken: boolean = true;

  constructor(private route: ActivatedRoute,
              private fb: FormBuilder,
              private authService: AuthService,
              private modalService: BsModalService,
              private globalMessageService: GlobalMessageService,
              private driftService: DriftService,
              private sentryService: SentryService)
               {
    this.passwordForm = fb.group({
      pw1: ['', Validators.compose([Validators.required, Validators.minLength(8), FormValidators.passwordMatchValidator, FormValidators.passwordRequirementValidator])],
      pw2: ['', Validators.compose([Validators.required, Validators.minLength(8), FormValidators.passwordMatchValidator])],
      accept: ['', Validators.required]
    });
    // so we can trigger match validator
    this.passwordForm.controls['pw2'].valueChanges.subscribe(() => {
      this.passwordForm.controls['pw1'].updateValueAndValidity();
    });
  }

  ngOnInit() {
    this.authService.logout().subscribe(
      (result: any) => {
        setTimeout(() => {
          this.visible = 'on';
        }, 10);
        this.initView();
      }
    )
  }

  acceptTerms() {
    this.passwordForm.controls['accept'].setValue(!this.passwordForm.controls['accept'].value);
  }

  submitForm() {
    const pw = this.passwordForm.controls['pw1'].value;
    this.passwordForm.controls['pw1'].setValue('');
    this.passwordForm.controls['pw2'].setValue('');
    this.authService.changePassword(this.token, this.emailAddress, pw).subscribe(
      (result: any) => {
        this.globalMessageService.message('Your password was changed, logging in...');
        setTimeout(() => {
          this.authService.login(this.emailAddress, pw).subscribe(
            () => {
              this.driftService.identify();
              this.driftService.track('new-user-pwchange');
              this.driftService.track('login');



              this.sentryService.identify();
            },
            () => {
              this.globalMessageService.error();
            }
          );
        }, 1500);
      },
      () => {
        this.globalMessageService.error();
      }
    );
  }

  invalidGoogleLogin(emailAddress: string) {
    this.googleEmailAddress = emailAddress;
    this.invalidGoogleDialogRef = this.modalService.show(this.invalidGoogleDialog);
  }

  private initView() {
    this.route.params.subscribe(
      (params) => {
        this.token = params['token'];
        this.authService.getEmailAddressByToken(params['token']).subscribe(
          (result: any) => {
            if (!result) {
              // invalid token
              this.validToken = false;
            }
            else {
              this.emailAddress = result.email_address;
            }
          },
          (error) => {
            this.globalMessageService.error();
          }
        );
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/new-user/new-user.component.ts